import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";

import "./ProductCard.css";

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const { isInWishlist, toggleWishlist } = useWishlist();

  const stock = Number(product.stock || 0);

  const hasSalePrice =
    product.salePrice !== null &&
    product.salePrice !== undefined &&
    Number(product.salePrice) < Number(product.price);

  const displayPrice = hasSalePrice ? product.salePrice : product.price;

  const handleAddToCart = () => {
    if (stock <= 0) {
      return;
    }

    addToCart(product);

    alert(`${product.name} added to cart`);
  };

  return (
    <article className="product-card">
      <div className="product-card-image-wrapper">
        <Link to={`/product/${product.id}`}>
          <img
            src={product.imageUrl}
            alt={product.name}
            className="product-card-image"
          />
        </Link>

        <button
          type="button"
          className={
            isInWishlist(product.id)
              ? "product-wishlist active"
              : "product-wishlist"
          }
          onClick={() => toggleWishlist(product)}
        >
          {isInWishlist(product.id) ? "♥" : "♡"}
        </button>

        {stock <= 0 && (
          <span className="product-stock-badge out">OUT OF STOCK</span>
        )}

        {stock > 0 && stock <= 3 && (
          <span className="product-stock-badge low">ONLY {stock} LEFT</span>
        )}
      </div>

      <div className="product-card-content">
        <p className="product-card-category">{product.category}</p>

        <Link to={`/product/${product.id}`} className="product-card-name">
          {product.name}
        </Link>

        <div className="product-card-price">
          {hasSalePrice ? (
            <>
              <span className="product-original-price">₹{product.price}</span>

              <span className="product-sale-price">₹{product.salePrice}</span>
            </>
          ) : (
            <span className="product-regular-price">₹{displayPrice}</span>
          )}
        </div>

        <button
          type="button"
          className="product-add-button"
          onClick={handleAddToCart}
          disabled={stock <= 0}
        >
          {stock <= 0 ? "Out of Stock" : "Add to Cart"}
        </button>
      </div>
    </article>
  );
};

export default ProductCard;
